<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Source Sans Pro", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  padding: 20px;
}
.btn.wtext {
    color: #fff !important;
}
.application.theme--light {
    background: #ffffff!important;
}
</style>
